import { render } from "./CulturalFitChart.vue?vue&type=template&id=6f8e7510&scoped=true"
import script from "./CulturalFitChart.vue?vue&type=script&lang=ts"
export * from "./CulturalFitChart.vue?vue&type=script&lang=ts"

import "./CulturalFitChart.vue?vue&type=style&index=0&id=6f8e7510&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6f8e7510"

export default script